import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import API from "../../utils/api";
import PaperCard from "./PaperCards";

const papers = [
  {
    id: 1,
    name: "Machine Learning for Beginners",
    date: "2024-01-01",
    link: "http://example.com/ml-for-beginners",
  },
  {
    id: 2,
    name: "Deep Learning Advances",
    date: "2024-02-01",
    link: "http://example.com/deep-learning-advances",
  },
  // Add more papers as needed
];

function Papers() {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/paper")
      .then((res) => res.data)
      .then((response) => {
        setData(response.papers);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  const handleSearch = (newData) => {
    setData(newData.learnings); // Update data based on date range picker response
  };
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent <strong className="purple">Papers</strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few machine learning papers I've read recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {data.map((paper) => (
            <Col md={4} className="project-card" key={paper.id}>
              <PaperCard
                id={paper.id}
                name={paper.title}
                date={paper.date}
                link={paper.link}
                refLink={paper.refLink}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}

export default Papers;
